export const logoSize = 130;
export const styleInputs = {
  height: 50,
  padding: 12
};